import { render, staticRenderFns } from "./FormulationCustomerLinksPopUp.vue?vue&type=template&id=71b0387d&"
import script from "./FormulationCustomerLinksPopUp.vue?vue&type=script&lang=js&"
export * from "./FormulationCustomerLinksPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports